module.exports = __webpack_public_path__ + "img/Шиндина-Татьяна-Сергеевна.d6fe88d0.png";